<template>
    <Dialog :visible="visible" @update:visible="$emit('update:visible', $event)" header="Subir documento"
        :style="{ width: '30rem' }" modal>
        <div class="formgrid grid">
            <div class="col-12">
                <label class="block text-500 text-sm mb-1">Tipo de documento *</label>
                <api-data-source :enable-cache="true" api-path="components_data/fk_document_option_list?applies_to=empresa">
                    <template v-slot="req">
                        <Dropdown class="w-full" :loading="req.loading" optionLabel="label" optionValue="value"
                            v-model="form.fk_document" :options="req.response"
                            placeholder="Selecciona un tipo de documento" />
                    </template>
                </api-data-source>
            </div>
            <div class="col-12 mt-3">
                <label class="block text-500 text-sm mb-1">Fecha de expedición *</label>
                <Calendar v-model="form.expedition" dateFormat="yy-mm-dd" class="w-full expedition-calendar" showIcon />
            </div>
            <div class="col-12 mt-3">
                <label class="block text-500 text-sm mb-1">Archivo (PDF o imagen, máx. 10MB) *</label>
                <input ref="fileInput" type="file" accept=".pdf,.jpg,.jpeg,.png" class="file-input-btn" @change="handleFileSelect" />
            </div>
            <div class="col-12 text-center mt-5 mb-0">
                <small v-if="error" class="p-error block mb-2">{{ error }}</small>
                <Button label="Subir" icon="pi pi-upload" class="upload-btn" :loading="uploading" @click="submit" />
            </div>
        </div>
    </Dialog>
</template>
<script setup>
import { reactive, ref, watch } from 'vue';
import { useApp } from 'src/composables/app.js';
import { ApiService } from 'src/services/api.js';

const props = defineProps({
    visible: { type: Boolean, default: false },
    companyId: { type: [String, Number], default: null },
});

const emit = defineEmits(['update:visible', 'uploaded']);

const app = useApp();

const fileInput = ref(null);
const form = reactive({ fk_document: null, expedition: null, file: null });
const error = ref('');
const uploading = ref(false);

watch(() => props.visible, (isVisible) => {
    if (isVisible) {
        form.fk_document = null;
        form.expedition = null;
        form.file = null;
        error.value = '';
        if (fileInput.value) fileInput.value.value = '';
    }
});

function handleFileSelect(event) {
    form.file = event.target.files?.[0] || null;
}

function toDateParam(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

async function submit() {
    error.value = '';

    if (!form.fk_document || !form.expedition || !form.file) {
        error.value = 'Selecciona el tipo de documento, la fecha de expedición y el archivo.';
        return;
    }

    const payload = new FormData();
    payload.append('fk_document', form.fk_document);
    payload.append('fk_company', props.companyId);
    payload.append('expedition', toDateParam(form.expedition));
    payload.append('file', form.file);

    uploading.value = true;
    try {
        await ApiService.postNoContentType('submission_documents/upload', payload);
        app.flashMsg('Versión subida', 'El documento se guardó correctamente en el NAS');
        emit('update:visible', false);
        emit('uploaded');
    } catch (err) {
        app.showPageRequestError(err);
    } finally {
        uploading.value = false;
    }
}
</script>
<style scoped>
.file-input-btn::file-selector-button {
    background: #3F51B5;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 0.65rem 1.25rem;
    font-family: inherit;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    margin-right: 0.75rem;
    transition: opacity 0.2s;
}

.file-input-btn::file-selector-button:hover {
    opacity: 0.85;
}

.expedition-calendar :deep(.p-datepicker-trigger) {
    background-color: #BD5757 !important;
    border-color: #BD5757 !important;
    color: #fff !important;
}

.expedition-calendar :deep(.p-datepicker-trigger:hover) {
    background-color: #a84a4a !important;
    border-color: #a84a4a !important;
}

.upload-btn {
    background-color: #6F95A3 !important;
    border-color: #6F95A3 !important;
}

.upload-btn:hover,
.upload-btn:active,
.upload-btn:focus {
    background-color: #082E3D !important;
    border-color: #082E3D !important;
}
</style>
